<template>
  <span v-if="isPWAInstallable">
    <slot 
      :install-pwa="installPWA"
      :is-pwa-installable="isPWAInstallable"
    >
      <b-button 
        @click="installPWA" 
        variant="outline-secondary"
      >
        <b-icon icon="download" class="mr-2" />
        Instaluj aplikację
      </b-button>
    </slot>
  </span>
</template>

<script>
export default {
  name: 'InstallPwa',
  data() {
    return {
      deferredPrompt: null,
      isPWAInstallable: false,
    }
  },
  mounted() {
    this.addEventListeners()
  },
  beforeDestroy() {
    this.removeEventListeners()
  },
  methods: {
    addEventListeners() {
      window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
      window.addEventListener('appinstalled', this.handleAppInstalled)
    },
    removeEventListeners() {
      window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
      window.removeEventListener('appinstalled', this.handleAppInstalled)
    },
    handleBeforeInstallPrompt(e) {
      e.preventDefault()
      this.deferredPrompt = e
      this.isPWAInstallable = true
    },
    handleAppInstalled() {
      this.isPWAInstallable = false
    },
    installPWA() {
      if (!this.deferredPrompt) {
        return
      }

      this.isPWAInstallable = false
      this.deferredPrompt.prompt()
      
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome !== 'accepted') {
          this.isPWAInstallable = true
        }
        this.deferredPrompt = null
      })
    },
  },
}
</script> 